import { BloomExperienceDetailsScreen } from "@/modules/bloom-experience";

/** Mobile Bloom Experience category details — `/bloom-experience-details?key=` */
export default function BloomExperienceDetailsRoute() {
  return <BloomExperienceDetailsScreen />;
}
